const ITINERARY_BLOCK_ID_PREFIX = "itinerary-";

export function getItineraryBlockElementId(blockId: string) {
  return `${ITINERARY_BLOCK_ID_PREFIX}${blockId}`;
}

function findScrollableAncestor(element: HTMLElement): HTMLElement | null {
  let current = element.parentElement;

  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    const canScroll =
      (overflowY === "auto" || overflowY === "scroll") &&
      current.scrollHeight > current.clientHeight;

    if (canScroll) {
      return current;
    }

    current = current.parentElement;
  }

  return null;
}

function getQuoteStickyHeaderOffset(): number {
  const stickyHeader = document.querySelector<HTMLElement>(
    "[data-quote-sticky-header]"
  );
  if (stickyHeader) {
    return stickyHeader.offsetHeight + 12;
  }

  return 16;
}

export function scrollToItineraryBlock(blockId: string) {
  window.dispatchEvent(
    new CustomEvent("trip-focus-itinerary", { detail: { blockId } })
  );

  const element = document.getElementById(getItineraryBlockElementId(blockId));
  if (!element) return;

  const stickyOffset = getQuoteStickyHeaderOffset();
  const scrollContainer = findScrollableAncestor(element);

  if (scrollContainer) {
    const containerTop = scrollContainer.getBoundingClientRect().top;
    const elementTop = element.getBoundingClientRect().top;
    const nextScrollTop =
      scrollContainer.scrollTop + (elementTop - containerTop) - stickyOffset;

    scrollContainer.scrollTo({ top: nextScrollTop, behavior: "smooth" });
    return;
  }

  const top =
    element.getBoundingClientRect().top + window.scrollY - stickyOffset;
  window.scrollTo({ top, behavior: "smooth" });
}
